import { ICompileService } from "angular";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import {
  GridConfiguration,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../records/views/recordGridView";
import {
  ColumnDefinitionSetService,
  ColumnDefinitionSetServiceProvider,
  vsServiceName as ColumnDefinitionSetServiceName,
  vsProviderName as ColumnDefinitionSetServiceProviderName,
} from "../../../records/grids/columns/columnDefinitionSetService";

import {
  machineObjectName,
  machineConfigurationObjectName,
} from "../../shared/names";
import { RecordDataSource } from "../../../records/grids";
import { defaultSort } from "./machineConfiguration";

Machine.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionSetServiceProviderName,
];

export const vsObjectName = machineObjectName;

export function Machine(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  columnDefinitionSetServiceProvider.addColumnDefinitionSet(vsObjectName, [
    ColumnDefinitionSetServiceName,
    (columnDefinitionSetService: ColumnDefinitionSetService) =>
      columnDefinitionSetService.getColumnDefinitionSet(
        machineConfigurationObjectName
      ),
  ]);

  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    ServerUtilityName,
    GridSettingsServiceName,
    (
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService
    ) => {
      const gridSettings = gridSettingsService.getGridSettings(
        Symbol("main.machine.grid")
      );
      const gridConfiguration: GridConfiguration = {
        columnDefinitionSet: vsObjectName,
        defaultSort,
        nameSingular: "Machine",
        namePlural: "Machines",
        gridDataSource: new RecordDataSource(
          serverUtility,
          "/api/machines/Machine"
        ),
        showAddButton: false,
        gridSettings,
      };
      return gridConfiguration;
    },
  ]);
}
